import { useAuth } from '../../contexts/AuthContext';
import { StaffRewardProgress } from '../rewards/StaffRewardProgress';
import { StaffRewardReview } from '../rewards/StaffRewardReview';

export const BonusPanel = () => {
  const { user } = useAuth();
  return <div className="py-5" data-testid="bonus-panel">{['admin','company_manager'].includes(user?.role)
    ? <StaffRewardReview/> : <StaffRewardProgress prefix="bonus-panel-progress"/>}</div>;
};